import { useEffect, useState, useCallback } from "react";
import { ITenderBid } from "../../types";
import { useAuthHeader } from "react-auth-kit";
import { isAxiosError } from "axios";
import axios from "../helper/axios";
import { apiURL } from "../helper/urls";

const useTenderBids = () => {
  const [tenderBids, setTenderBids] = useState<ITenderBid[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const getAuthHeader = useAuthHeader();
  const rawHeader = getAuthHeader();
  const token = typeof rawHeader === "string" && rawHeader ? rawHeader.replace(/^Bearer\s+/i, "") : null;

  const fetchTenderBids = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    setError(null);
    try {
      const { data } = await axios.post(
        // The same list the web app's dashboard loads (get_bids_list is legacy and
        // fails for some accounts).
        apiURL("get_bid_list_scaffolding"),
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      setTenderBids(data.bids || []);
    } catch (err: unknown) {
      const detail =
        isAxiosError(err) && typeof err.response?.data?.detail === "string" ? err.response.data.detail : null;
      setError(detail ?? (err instanceof Error ? err.message : "Failed to fetch tenders"));
    }
    setLoading(false);
  }, [token]);

  useEffect(() => {
    if (token) {
      fetchTenderBids();
    }
  }, [token, fetchTenderBids]);

  return { tenderBids, loading, error, fetchTenderBids };
};

export default useTenderBids;
